// extracted by mini-css-extract-plugin
export var card = "_ve-0";
export var details = "_ve-1";